import styled from 'styled-components';
import { SubH, SmallP } from '../../style/typography';
import { colors } from '../../style/colors';

const ScheduleSpeakerName = styled(SmallP)`
  color: ${props => (props.isInPerson ? colors.BLACK : colors.WHITE)};
`;

const ScheduleSpeakerPosition = styled(SubH)`
  color: ${props => (props.isInPerson ? colors.BLACK : colors.WHITE)};
  margin-top: ${props => (props.onlyPosition ? '1.4rem' : '-1rem')};
`;

const ScheduleSpeakerContainer = styled.div`
  display: block;
`;

export {
  ScheduleSpeakerName,
  ScheduleSpeakerPosition,
  ScheduleSpeakerContainer,
};
